export const scrapedPsyc = [
        {
        "address2_postalcode": "SW19 1JW",
        "contactid": "b49bd04e-155b-eb11-a812-00224840f431",
        "address2_line2": "49 Kingston Road",
        "address2_line1": "Wimbledon Lifestyle",
        "address2_country": "United Kingdom",
        "address2_longitude": "-0.19467",
        "salutation": "Dr Maura Abdelall CPsychol",
        "fullname": "Maura Abdelall",
        "address2_city": "London",
        "address2_composite": "Wimbledon Lifestyle\r\n49 Kingston Road\r\nLondon\r\nSW19 1JW\r\nUnited Kingdom",
        "address2_latitude": "51.41564",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Abdelall",
        "email": "macounsellingpsych@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "macounsellingpsych@gmail.com",
        "website": "http://www.macounsellingpsychology.co.uk/",
        "typeOfTreatment": [
            "Work Stress",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Abuse",
            "Self Esteem & Self Development",
            "Relationships",
            "PTSD",
            "Panic Disorder",
            "OCD",
            "Grief and Loss",
            "Depression",
            "Anxiety & Phobias",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_postalcode": "BA5 1RZ",
        "contactid": "c3c6014e-b067-eb11-a812-00224840e31b",
        "address2_line2": "Lower Godney",
        "address2_line1": "Manor Farm Cottage",
        "address2_country": "United Kingdom",
        "address2_longitude": "-2.75481",
        "salutation": "Dr Adam Abdelnoor CPsychol AFBPsS",
        "fullname": "Adam Abdelnoor",
        "address2_city": "Wells",
        "address2_composite": "Manor Farm Cottage\r\nLower Godney\r\nWells\r\nBA5 1RZ\r\nUnited Kingdom",
        "address2_latitude": "51.18170",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Abdelnoor",
        "email": "dr.adam@abdelnoor.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "dr.adam@abdelnoor.com",
        "website": "http://www.abdelnoor.com/",
        "typeOfTreatment": [
            "Teaching",
            "School Issues",
            "Relationships",
            "Psychological Research",
            "Parenting",
            "Managerial Advice / Consultancy",
            "Management of Offenders",
            "Learning Difficulties",
            "Leadership",
            "Intellectual Disability",
            "Impairment Assessment",
            "Grief and Loss",
            "Family Court Issues",
            "Expert Witness",
            "Conflict Resolution",
            "Community Consultation / Evaluation",
            "Bullying",
            "Behaviour Problems",
            "Autism",
            "Assessment of Offenders",
            "Aspergers",
            "Anxiety & Phobias",
            "Academic Performance"
        ]
    },
    {
        "address2_city": "ALTRINCHAM",
        "address2_line3": "Bowdon",
        "address2_line2": "Vicarage Lane",
        "address2_county": "Cheshire",
        "address2_postalcode": "WA14 3ET",
        "address2_line1": "2 Huxley Terrace",
        "salutation": "Ms Corinne Abisgold CPsychol",
        "contactid": "66f44f02-175b-eb11-a812-00224840fbeb",
        "sbbps_donotincludedirectoryaddress": "No",
        "address2_composite": "2 Huxley Terrace\r\nVicarage Lane\r\nBowdon\r\nALTRINCHAM\r\nWA14 3ET\r\nUnited Kingdom",
        "lastname": "Abisgold",
        "fullname": "Corinne Abisgold",
        "address2_country": "United Kingdom",
        "address2_latitude": "53.37167",
        "address2_longitude": "-2.36082",
        "email": "cabisgold@yahoo.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "cabisgold@yahoo.co.uk",
        "website": "https://www.corinneabisgold.co.uk/",
        "typeOfTreatment": []
    },
    {
        "address2_postalcode": "L39 4QP",
        "contactid": "6cefecc7-9b5a-eb11-a812-00224840f431",
        "address2_line2": "St. Helens Road",
        "address2_line1": "Edge Hill University",
        "address2_country": "United Kingdom",
        "address2_longitude": "-2.87383",
        "salutation": "Dr Maria-Christina Kosteli CPsychol AFBPsS",
        "fullname": "Maria-Christina Kosteli",
        "address2_city": "ORMSKIRK",
        "address2_composite": "Edge Hill University\r\nSt. Helens Road\r\nORMSKIRK\r\nL39 4QP\r\nUnited Kingdom",
        "address2_latitude": "53.55962",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Kosteli",
        "email": "maria.kosteli@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "maria.kosteli@gmail.com",
        "website": "https://www.mckosteli.com/",
        "typeOfTreatment": [
            "Work Stress",
            "Teaching",
            "Stress Management",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "Psychological Research",
            "Personality Assessment",
            "Performance in Sport",
            "Motivation in Sport",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Family problems",
            "Divorce / Separation",
            "Cross-cultural",
            "Conflict Resolution",
            "Cognitive Behavioural Therapy (CBT)",
            "Bullying",
            "Assessment / Measurement in Sport",
            "Assertiveness Training",
            "Academic Performance"
        ]
    },
    {
        "address2_postalcode": "CM2 6JE",
        "contactid": "74ff6cd6-155b-eb11-a812-00224840fbeb",
        "address2_line2": "64-66 Springfield Road",
        "address2_line1": "Suite 6 Burgundy Court",
        "address2_country": "United Kingdom",
        "address2_longitude": "0.47657",
        "salutation": "Dr Jacqueline Edwards CPsychol AFBPsS",
        "address2_county": "Essex",
        "fullname": "Jacqueline Edwards",
        "address2_city": "Chelmsford",
        "address2_composite": "Suite 6 Burgundy Court\r\n64-66 Springfield Road\r\nChelmsford\r\nCM2 6JE\r\nUnited Kingdom",
        "address2_latitude": "51.73281",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Edwards",
        "email": "j.edwards.cpsychol@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "j.edwards.cpsychol@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Mental Illness",
            "Couples Therapy",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "contactid": "ee3810b1-8d5a-eb11-a812-00224840fbeb",
        "address2_longitude": "0.00000",
        "address2_country": "United Kingdom",
        "salutation": "Dr Joanne Ablett CPsychol AFBPsS",
        "fullname": "Joanne Ablett",
        "address2_composite": "United Kingdom",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ablett",
        "email": "flowcp@icloud.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "flowcp@icloud.com",
        "website": "",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Vocational Assessment & Career Issues",
            "Victim of Crime",
            "Terminal Illness",
            "Teaching",
            "Suicide",
            "Stress Management",
            "Smoking Cessation",
            "Sleeping Disorders",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychological Research",
            "Post-natal Depression",
            "Performance Management",
            "Performance in Sport",
            "Panic Disorder",
            "Pain Management",
            "Orphanages / Children's Home Issues",
            "Organisational Restructuring",
            "Organisational Environment",
            "OCD",
            "Motivation in Sport",
            "Memory Problems",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Legal Report",
            "Learning Difficulties",
            "Leadership",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Infertility Issues",
            "Impairment Assessment",
            "Human Resource Management",
            "Health-related Problems",
            "Grief and Loss",
            "Expert Witness",
            "Dyscalculia",
            "Domestic Violence",
            "Divorce / Separation",
            "Disaster / Terrorism"
        ]
    },
    {
        "address2_postalcode": "CR7 6DW",
        "contactid": "47ebddfb-915a-eb11-a812-00224840fbeb",
        "address2_longitude": "0.00000",
        "address2_line1": "London & Home Counties",
        "address2_country": "United Kingdom",
        "salutation": "Dr Venetia Kotaki CPsychol",
        "fullname": "Venetia Kotaki",
        "address2_composite": "London & Home Counties\r\nCR7 6DW\r\nUnited Kingdom",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Kotaki",
        "email": "venetia.kotaki@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "venetia.kotaki@gmail.com",
        "website": "http://www.counselling-directory.org.uk/counsellors/venetia-kotaki",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Victim of Crime",
            "Suicide",
            "Stress Management",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "School Issues",
            "Relaxation",
            "Relationships",
            "PTSD",
            "Psychopathology Assessment",
            "Post-natal Depression",
            "Personality Disorders",
            "Parenting",
            "Panic Disorder",
            "OCD",
            "Mental Illness",
            "Mediation",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Impulsive Behaviours",
            "Health-related Problems",
            "Grief and Loss",
            "Domestic Violence",
            "Divorce / Separation",
            "Depression",
            "Couples Therapy",
            "Conflict Resolution",
            "Carer Support",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "Academic Performance"
        ]
    },
    {
        "contactid": "db03bb70-b067-eb11-a812-0022484176b9",
        "address2_longitude": "0.00000",
        "address2_country": "United Kingdom",
        "salutation": "Dr Stephanie Edwards CPsychol",
        "address2_county": "Southend on Sea",
        "fullname": "Stephanie Edwards",
        "address2_composite": "United Kingdom",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Edwards",
        "email": "enquiries@stephanieedwards.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "enquiries@stephanieedwards.co.uk",
        "website": "",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Victim of Crime",
            "Suicide",
            "Substance Abuse",
            "Stress Management",
            "Sexual Abuse",
            "Sex Offenders",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relationships",
            "PTSD",
            "Post-natal Depression",
            "Personality Disorders",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "OCD",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Impulsive Behaviours",
            "Grief and Loss",
            "Gambling",
            "Family problems",
            "Domestic Violence",
            "Divorce / Separation",
            "Dissociative Identity Disorder",
            "Disaster / Terrorism",
            "Depression",
            "Cult Involvement",
            "Criminal Behaviour",
            "Conflict Resolution",
            "Cognitive Behavioural Therapy (CBT)",
            "Carer Support",
            "Bullying",
            "Behaviour Problems",
            "Autism",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "Adoption"
        ]
    },
    {
        "address2_postalcode": "HP5 1BU",
        "contactid": "f643f634-5e5a-eb11-a812-00224840f431",
        "address2_line2": "High Street",
        "address2_line1": "Laceys Yard",
        "address2_country": "United Kingdom",
        "address2_longitude": "-0.61247",
        "salutation": "Mr Reinhard Kowalski CPsychol AFBPsS",
        "fullname": "Reinhard Kowalski",
        "address2_city": "CHESHAM",
        "address2_composite": "Laceys Yard\r\nHigh Street\r\nCHESHAM\r\nHP5 1BU\r\nUnited Kingdom",
        "address2_latitude": "51.70474",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Kowalski",
        "email": "reinhard@talk21.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "reinhard@talk21.com",
        "website": "http://www.mind-balancing.co.uk/",
        "typeOfTreatment": [
            "Work Stress",
            "Victim of Crime",
            "Suicide",
            "Substance Abuse",
            "Stress Management",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "PTSD",
            "Psychosis",
            "Post-natal Depression",
            "Personality Disorders",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "OCD",
            "Mental Illness",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Impulsive Behaviours",
            "Health-related Problems",
            "Grief and Loss",
            "Family Court Issues",
            "Domestic Violence",
            "Dissociative Identity Disorder",
            "Disaster / Terrorism",
            "Depression",
            "Couples Therapy",
            "Conflict Resolution",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_postalcode": "HA7 3HX",
        "contactid": "84e5605e-155b-eb11-a812-00224840fbeb",
        "address2_longitude": "-0.33683",
        "address2_line1": "1 Sussex Villas, Common Road",
        "address2_country": "United Kingdom",
        "salutation": "Dr Anna Abramowski CPsychol",
        "fullname": "Anna Abramowski",
        "address2_city": "London",
        "address2_composite": "1 Sussex Villas, Common Road\r\nLondon\r\nHA7 3HX\r\nUnited Kingdom",
        "address2_latitude": "51.63082",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Abramowski",
        "email": "",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "",
        "website": "http://www.northlondonpsychologists.com/home",
        "typeOfTreatment": []
    },
    {
        "address2_postalcode": "OX16 9XP",
        "contactid": "13227ac0-165b-eb11-a812-00224840fbeb",
        "address2_longitude": "-1.33098",
        "address2_line1": "Foscote Private Hospital, 2 Foscote Rise",
        "address2_country": "United Kingdom",
        "salutation": "Dr Selena Elcombe CPsychol",
        "fullname": "Selena Elcombe",
        "address2_city": "Banbury",
        "address2_composite": "Foscote Private Hospital, 2 Foscote Rise\r\nBanbury\r\nOX16 9XP\r\nUnited Kingdom",
        "address2_latitude": "52.05335",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Elcombe",
        "email": "selena.elcombe@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "selena.elcombe@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Stress Management",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "PTSD",
            "Post-natal Depression",
            "Panic Disorder",
            "OCD",
            "Life Transition & Adjustment Issues",
            "Grief and Loss",
            "Depression",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_postalcode": "WA3 6LY",
        "contactid": "e319c357-ac5a-eb11-a812-00224840fbeb",
        "address2_line2": "Birchwood",
        "address2_line1": "2 Ledsham Close",
        "address2_country": "United Kingdom",
        "address2_longitude": "-2.53683",
        "salutation": "Dr Omar Kowlessar CPsychol AFBPsS",
        "address2_county": "Cheshire",
        "fullname": "Omar Kowlessar",
        "address2_city": "WARRINGTON",
        "address2_composite": "2 Ledsham Close\r\nBirchwood\r\nWARRINGTON\r\nWA3 6LY\r\nUnited Kingdom",
        "address2_latitude": "53.41852",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Kowlessar",
        "email": "dr.okowlessar@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "dr.okowlessar@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Work Stress",
            "Teaching",
            "Stress Management",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "PTSD",
            "Psychological Research",
            "Personality Disorders",
            "Panic Disorder",
            "Pain Management",
            "OCD",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Leadership",
            "Health-related Problems",
            "Grief and Loss",
            "Eating Disorders",
            "Depression",
            "Cognitive Behavioural Therapy (CBT)",
            "Chronic Disease Management",
            "Carer Support",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Autism",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "ADHD"
        ]
    },
    {
        "address2_postalcode": "LL57 1NR",
        "contactid": "010d293a-7f5a-eb11-a812-00224840fbeb",
        "address2_line3": "Bangor",
        "address2_line2": "High Street",
        "address2_line1": "65",
        "address2_country": "United Kingdom",
        "address2_longitude": "-4.13056",
        "salutation": "Dr Karen Addy CPsychol AFBPsS",
        "fullname": "Karen Addy",
        "address2_city": "Gwynedd",
        "address2_composite": "65\r\nHigh Street\r\nBangor\r\nGwynedd\r\nLL57 1NR\r\nUnited Kingdom",
        "address2_latitude": "53.22359",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Addy",
        "email": "Enquiries@NWNeuro.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "Enquiries@NWNeuro.co.uk",
        "website": "",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Vocational Assessment & Career Issues",
            "Victim of Crime",
            "Teaching",
            "Stress Management",
            "Self Esteem & Self Development",
            "Relationships",
            "Rehab / Injury Counselling",
            "PTSD",
            "Psychological Research",
            "Post-natal Depression",
            "Panic Disorder",
            "Pain Management",
            "Organisational Restructuring",
            "Organisational Environment",
            "OCD",
            "Neuropsychological Treatment / Rehabilitation",
            "Neuropsychological Assessment",
            "Mental Illness",
            "Memory Problems",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Legal Report",
            "Learning Difficulties",
            "Leadership",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Impulsive Behaviours",
            "Impairment Assessment",
            "Human Resource Management",
            "Health-related Problems",
            "Grief and Loss",
            "Expert Witness",
            "Divorce / Separation",
            "Depression",
            "Criminal Behaviour",
            "Conflict Resolution",
            "Chronic Disease Management",
            "Carer Support",
            "Bullying",
            "Behaviour Problems",
            "Assessment of Offenders",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management"
        ]
    },
    {
        "address2_postalcode": "EH11 4BN",
        "contactid": "c2a5ee95-795a-eb11-a812-00224840fbeb",
        "address2_line3": "Edinburgh Napier University",
        "address2_line2": "Sighthill Campus - Psychology Department",
        "address2_line1": "School Of Applied Sciences",
        "address2_country": "United Kingdom",
        "address2_longitude": "-3.28847",
        "salutation": "Mr Marc Kozlowski CPsychol AFBPsS",
        "fullname": "Marc Kozlowski",
        "address2_city": "EDINBURGH",
        "address2_composite": "School Of Applied Sciences\r\nSighthill Campus - Psychology Department\r\nEdinburgh Napier University\r\nEDINBURGH\r\nEH11 4BN\r\nUnited Kingdom",
        "address2_latitude": "55.92407",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Kozlowski",
        "email": "m.kozlowski@napier.ac.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "m.kozlowski@napier.ac.uk",
        "website": "",
        "typeOfTreatment": [
            "Sex Offenders",
            "Management of Offenders",
            "Legal Report",
            "Family Court Issues",
            "Expert Witness",
            "Criminal Behaviour"
        ]
    },
    {
        "address2_city": "CHELMSFORD",
        "address2_line3": "Parkway",
        "address2_line2": "Moulsham Mill",
        "address2_county": "Essex",
        "address2_postalcode": "CM2 7PX",
        "address2_line1": "Cornerstone Psychological Services",
        "salutation": "Mrs Abigael Eldred CPsychol AFBPsS",
        "contactid": "ec7f455c-185b-eb11-a812-00224840f431",
        "sbbps_donotincludedirectoryaddress": "No",
        "address2_composite": "Cornerstone Psychological Services\r\nMoulsham Mill\r\nParkway\r\nCHELMSFORD\r\nCM2 7PX\r\nUnited Kingdom",
        "lastname": "Eldred",
        "fullname": "Abigael Eldred",
        "address2_country": "United Kingdom",
        "address2_latitude": "51.72810",
        "address2_longitude": "0.48179",
        "email": "",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "",
        "website": "http://www.cstone.org.uk/",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Suicide",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "PTSD",
            "Psychosis",
            "Post-natal Depression",
            "Personality Disorders",
            "Panic Disorder",
            "OCD",
            "Mental Illness",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Grief and Loss",
            "Domestic Violence",
            "Depression",
            "Bullying",
            "Bipolar Disorder",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_postalcode": "E1 6BJ",
        "contactid": "c729412a-165b-eb11-a812-00224840fbeb",
        "address2_longitude": "-0.07535",
        "address2_line1": "147 Commercial Street",
        "address2_country": "United Kingdom",
        "salutation": "Dr Yetunde Ade-Serrano CPsychol FBPsS",
        "address2_county": "London",
        "fullname": "Yetunde Ade-Serrano",
        "address2_city": "London",
        "address2_composite": "147 Commercial Street\r\nLondon\r\nE1 6BJ\r\nUnited Kingdom",
        "address2_latitude": "51.52091",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ade-Serrano",
        "email": "yade15@hotmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "yade15@hotmail.com",
        "website": "",
        "typeOfTreatment": [
            "Work Stress",
            "Suicide",
            "Stress Management",
            "Self Esteem & Self Development",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Race / Gender / Sexuality",
            "Parenting",
            "Panic Disorder",
            "Grief and Loss",
            "Family problems",
            "Domestic Violence",
            "Divorce / Separation",
            "Depression",
            "Cross-cultural",
            "Couples Therapy",
            "Conflict Resolution",
            "Bullying",
            "Behaviour Problems",
            "Anxiety & Phobias"
        ]
    },
    {
        "contactid": "ed25d8bc-8f67-eb11-a812-0022484176b9",
        "address2_longitude": "-1.49266",
        "salutation": "Dr Jane Adlard CPsychol AFBPsS",
        "fullname": "Jane Adlard",
        "address2_latitude": "53.37424",
        "sbbps_donotincludedirectoryaddress": "hidden",
        "lastname": "Adlard",
        "email": "j.adlard@shu.ac.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "j.adlard@shu.ac.uk",
        "website": "",
        "typeOfTreatment": [
            "Sex Offenders",
            "Management of Offenders",
            "Criminal Behaviour"
        ]
    },
    {
        "address2_postalcode": "CT11",
        "contactid": "f293ac99-ac5c-eb11-a812-00224840f431",
        "address2_longitude": "1.40112",
        "address2_country": "United Kingdom",
        "salutation": "Ms Clare Eldred CPsychol AFBPsS",
        "fullname": "Clare Eldred",
        "address2_city": "Ramsgate",
        "address2_composite": "Ramsgate\r\nCT11\r\nUnited Kingdom",
        "address2_latitude": "51.33342",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Eldred",
        "email": "clareeldred@aol.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "clareeldred@aol.com",
        "website": "",
        "typeOfTreatment": [
            "Stress Management",
            "Sleeping Disorders",
            "Self Esteem & Self Development",
            "Relaxation",
            "Rehab / Injury Counselling",
            "Psychological Research",
            "Pain Management",
            "Neuropsychological Treatment / Rehabilitation",
            "Memory Problems",
            "Life Transition & Adjustment Issues",
            "Health-related Problems"
        ]
    },
    {
        "contactid": "db5b4c0b-8b5a-eb11-a812-00224840f431",
        "address2_longitude": "0.00000",
        "address2_line1": "North Wales",
        "address2_country": "United Kingdom",
        "salutation": "Dr Sarah Kriakous CPsychol AFBPsS",
        "fullname": "Sarah Kriakous",
        "address2_composite": "North Wales\r\nUnited Kingdom",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "hidden",
        "lastname": "Kriakous",
        "email": "drsarahkriakous@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "drsarahkriakous@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Substance Abuse",
            "Stress Management",
            "Smoking Cessation",
            "Sleeping Disorders",
            "Sexual Abuse",
            "Sex Offenders",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "PTSD",
            "Psychosis",
            "Psychopathology Assessment",
            "Post-natal Depression",
            "Personality Disorders",
            "Personality Assessment",
            "Parenting",
            "Panic Disorder",
            "OCD",
            "Neuropsychological Assessment",
            "Memory Problems",
            "Management of Offenders",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Learning Difficulties",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Impulsive Behaviours",
            "Grief and Loss",
            "Gambling",
            "Family problems",
            "Family Court Issues",
            "Expert Witness",
            "Domestic Violence",
            "Divorce / Separation",
            "Dissociative Identity Disorder",
            "Depression",
            "Dementia",
            "Criminal Behaviour",
            "Conflict Resolution",
            "Cognitive Behavioural Therapy (CBT)",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems"
        ]
    },
    {
        "address2_postalcode": "TN15 6NA",
        "contactid": "177beda1-795a-eb11-a812-00224840fbeb",
        "address2_longitude": "0.23004",
        "address2_country": "United Kingdom",
        "salutation": "Dr Jill Aebi-Mytton CPsychol AFBPsS",
        "fullname": "Jill Aebi-Mytton",
        "address2_city": "Sevenoaks",
        "address2_composite": "Sevenoaks\r\nTN15 6NA\r\nUnited Kingdom",
        "address2_latitude": "51.30604",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Aebi-Mytton",
        "email": "drjillmytton@proton.me",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "drjillmytton@proton.me",
        "website": "",
        "typeOfTreatment": [
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Stress Management",
            "Sexual Abuse",
            "Self Harm",
            "Religious Issues",
            "PTSD",
            "Psychological Research",
            "Mental Illness",
            "Life Transition & Adjustment Issues",
            "Grief and Loss",
            "Domestic Violence",
            "Disaster / Terrorism",
            "Depression",
            "Cult Involvement",
            "Carer Support",
            "Bullying",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Adult Survivors of Sexual Abuse",
            "Academic Performance"
        ]
    },
    {
        "address2_postalcode": "KT12 3AA",
        "contactid": "cd28a88c-7c5a-eb11-a812-00224840fbeb",
        "address2_longitude": "-0.40659",
        "address2_line1": "WALTON-ON-THAMES",
        "address2_country": "United Kingdom",
        "salutation": "Mrs Margaret Kwilman-Klelund CPsychol AFBPsS",
        "fullname": "Margaret Kwilman-Klelund",
        "address2_composite": "WALTON-ON-THAMES\r\nKT12 3AA\r\nUnited Kingdom",
        "address2_latitude": "51.37736",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Kwilman-Klelund",
        "email": "malgosia_kk@hotmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "malgosia_kk@hotmail.com",
        "website": "",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Vocational Assessment & Career Issues",
            "Victim of Crime",
            "Terminal Illness",
            "Substance Abuse",
            "Stress Management",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "School Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "PTSD",
            "Psychopathology Assessment",
            "Post-natal Depression",
            "Personality Disorders",
            "Personality Assessment",
            "Parenting",
            "Panic Disorder",
            "OCD",
            "Life Transition & Adjustment Issues",
            "Intellectual Assessment",
            "Infertility Issues",
            "Impairment Assessment",
            "Health-related Problems",
            "Grief and Loss",
            "Gender / Sexual Identity Disorders",
            "Eating Disorders",
            "Domestic Violence",
            "Divorce / Separation",
            "Depression",
            "Cross-cultural",
            "Couples Therapy",
            "Conflict Resolution",
            "Chronic Disease Management",
            "Carer Support",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Autism",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "Adoption",
            "ADHD",
            "Academic Performance"
        ]
    },
    {
        "address2_postalcode": "NR9 3DB",
        "contactid": "99296bd0-155b-eb11-a812-00224840fbeb",
        "address2_line3": "28 Queens Road, Hethersett",
        "address2_line2": "Rowan House Centre",
        "address2_line1": "Norfolk Psychology",
        "address2_country": "United Kingdom",
        "address2_longitude": "1.18215",
        "salutation": "Dr Amelia Eleftheriades CPsychol",
        "fullname": "Amelia Eleftheriades",
        "address2_city": "NORWICH",
        "address2_composite": "Norfolk Psychology\r\nRowan House Centre\r\n28 Queens Road, Hethersett\r\nNORWICH\r\nNR9 3DB\r\nUnited Kingdom",
        "address2_latitude": "52.59915",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Eleftheriades",
        "email": "amelia@norfolkpsychology.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "amelia@norfolkpsychology.com",
        "website": "",
        "typeOfTreatment": [
            "Teaching",
            "Stress Management",
            "Sexual Difficulties",
            "Self Esteem & Self Development",
            "School Issues",
            "Relationships",
            "Learning Difficulties",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Impulsive Behaviours",
            "Impairment Assessment",
            "Health-related Problems",
            "Couples Therapy",
            "Community Consultation / Evaluation",
            "Chronic Disease Management",
            "Bullying",
            "Behaviour Problems",
            "Autism",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias"
        ]
    },
    {
        "address2_postalcode": "SW12 9NN",
        "contactid": "23c75e42-195b-eb11-a812-00224840f431",
        "address2_longitude": "-0.14565",
        "address2_line1": "85 Gaskarth Road",
        "address2_country": "United Kingdom",
        "salutation": "Ms Olatayo Afuape CPsychol AFBPsS",
        "fullname": "Olatayo Afuape",
        "address2_city": "London",
        "address2_composite": "85 Gaskarth Road\r\nLondon\r\nSW12 9NN\r\nUnited Kingdom",
        "address2_latitude": "51.45138",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Afuape",
        "email": "afuapeolatayo@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "afuapeolatayo@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "School Issues",
            "Learning Difficulties",
            "Intellectual Assessment",
            "Behaviour Problems",
            "Autism",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "ADHD",
            "Academic Performance"
        ]
    },
    {
        "address2_city": "Headington",
        "address2_line3": "Warneford Lane, Oxford",
        "address2_line2": "Warneford Hospital",
        "address2_county": "Oxfordshire",
        "address2_postalcode": "OX3 7JX",
        "address2_line1": "Isis Education Centre",
        "salutation": "Dr Sarah Lack CPsychol",
        "contactid": "f04b51e1-8f5a-eb11-a812-00224840f431",
        "sbbps_donotincludedirectoryaddress": "No",
        "address2_composite": "Isis Education Centre\r\nWarneford Hospital\r\nWarneford Lane, Oxford\r\nHeadington\r\nOX3 7JX\r\nUnited Kingdom",
        "lastname": "Lack",
        "fullname": "Sarah Lack",
        "address2_country": "United Kingdom",
        "address2_latitude": "51.75085",
        "address2_longitude": "-1.22230",
        "email": "sarah.lack@hmc.ox.ac.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "sarah.lack@hmc.ox.ac.uk",
        "website": "",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Victim of Crime",
            "Terminal Illness",
            "Suicide",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychological Research",
            "Post-natal Depression",
            "Personality Disorders",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "OCD",
            "Memory Problems",
            "Mediation",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Infertility Issues",
            "Health-related Problems",
            "Grief and Loss",
            "Gender / Sexual Identity Disorders",
            "Family problems",
            "Domestic Violence",
            "Divorce / Separation",
            "Disaster / Terrorism",
            "Depression",
            "Dementia",
            "Cult Involvement",
            "Cross-cultural",
            "Couples Therapy",
            "Conflict Resolution",
            "Cognitive Behavioural Therapy (CBT)",
            "Chronic Disease Management",
            "Carer Support",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Aspergers"
        ]
    },
    {
        "address2_postalcode": "SE22 8EP",
        "contactid": "c4d03eb1-165b-eb11-a812-00224840f431",
        "address2_line3": "47, Lordship Lane, East Dulwich",
        "address2_line2": "Integrated Health Centre",
        "address2_line1": "Dulwich Therapy Rooms",
        "address2_country": "United Kingdom",
        "address2_longitude": "-0.07478",
        "salutation": "Mrs Eleanor Ellis CPsychol",
        "fullname": "Eleanor Ellis",
        "address2_city": "London",
        "address2_composite": "Dulwich Therapy Rooms\r\nIntegrated Health Centre\r\n47, Lordship Lane, East Dulwich\r\nLondon\r\nSE22 8EP\r\nUnited Kingdom",
        "address2_latitude": "51.45904",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ellis",
        "email": "janeellispsychologist@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "janeellispsychologist@gmail.com",
        "website": "http://janeellispsychologist.com/",
        "typeOfTreatment": [
            "Work Stress",
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Self Esteem & Self Development",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychosis",
            "Psychological Research",
            "Post-natal Depression",
            "Personality Disorders",
            "Panic Disorder",
            "OCD",
            "Neuropsychological Assessment",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Grief and Loss",
            "Family problems",
            "Domestic Violence",
            "Disaster / Terrorism",
            "Depression",
            "Cognitive Behavioural Therapy (CBT)",
            "Carer Support",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "contactid": "be34b778-155b-eb11-a812-00224840f431",
        "address2_longitude": "-0.16532",
        "address2_country": "United Kingdom",
        "salutation": "Dr Sarah Afuwape CPsychol AFBPsS",
        "fullname": "Sarah Afuwape",
        "address2_city": "London",
        "address2_composite": "London\r\nUnited Kingdom",
        "address2_latitude": "51.55322",
        "sbbps_donotincludedirectoryaddress": "hidden",
        "lastname": "Afuwape",
        "email": "sarah.afuwape@nhs.net",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "sarah.afuwape@nhs.net",
        "website": "http://www.iop.kcl.ac.uk/",
        "typeOfTreatment": [
            "Stress Management",
            "Relaxation",
            "Psychological Research",
            "Panic Disorder",
            "Health-related Problems",
            "Depression",
            "Chronic Disease Management",
            "Anxiety & Phobias"
        ]
    },
    {
        "address2_postalcode": "LS17 8FH",
        "contactid": "5189bc72-155b-eb11-a812-00224840f431",
        "address2_line3": "West Yorkshire",
        "address2_longitude": "-1.51789",
        "address2_line1": "8 Stoneleigh Close",
        "address2_country": "United Kingdom",
        "salutation": "Dr Sharon Ladak CPsychol",
        "fullname": "Sharon Ladak",
        "address2_city": "LEEDS",
        "address2_composite": "8 Stoneleigh Close\r\nWest Yorkshire\r\nLEEDS\r\nLS17 8FH\r\nUnited Kingdom",
        "address2_latitude": "53.85149",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ladak",
        "email": "info@ladakpsychologypractice.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "info@ladakpsychologypractice.co.uk",
        "website": "https://www.thecandidpsychologist.co.uk/",
        "typeOfTreatment": [
            "Teaching",
            "Stress Management",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Race / Gender / Sexuality",
            "Psychological Research",
            "Panic Disorder",
            "Orphanages / Children's Home Issues",
            "Memory Problems",
            "Learning Difficulties",
            "Intellectual Disability",
            "Grief and Loss",
            "Family problems",
            "Divorce / Separation",
            "Depression",
            "Bullying",
            "Behaviour Problems",
            "Autism",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "ADHD",
            "Academic Performance"
        ]
    },
    {
        "contactid": "248a8187-8c5a-eb11-a812-00224840f431",
        "address2_longitude": "0.00000",
        "address2_country": "United Kingdom",
        "salutation": "Dr Sonia Ellis CPsychol AFBPsS",
        "fullname": "Sonia Ellis",
        "address2_composite": "United Kingdom",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ellis",
        "email": "ellispsychologyconsults@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "ellispsychologyconsults@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Work Stress",
            "Teaching",
            "Self Esteem & Self Development",
            "School Issues",
            "Psychological Research",
            "Personality Assessment",
            "Learning Difficulties",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Academic Performance"
        ]
    },
    {
        "contactid": "34bcb5bb-005b-eb11-a812-00224840fbeb",
        "address2_longitude": "-2.12642",
        "address2_country": "United Kingdom",
        "salutation": "Dr Alessio Agostinis CPsychol AFBPsS",
        "address2_county": "Jersey",
        "fullname": "Alessio Agostinis",
        "address2_composite": "United Kingdom",
        "address2_latitude": "49.18170",
        "sbbps_donotincludedirectoryaddress": "hidden",
        "lastname": "Agostinis",
        "email": "office@dragostinis.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "office@dragostinis.co.uk",
        "website": "http://www.dragostinis.co.uk/",
        "typeOfTreatment": [
            "Work Stress",
            "Victim of Crime",
            "Teaching",
            "Substance Abuse",
            "Stress Management",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychological Research",
            "Post-natal Depression",
            "Panic Disorder",
            "Pain Management",
            "OCD",
            "Motivation in Sport",
            "Mental Illness",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Legal Report",
            "Learning Difficulties",
            "Intellectual Assessment",
            "Impairment Assessment",
            "Health-related Problems",
            "Grief and Loss",
            "Expert Witness",
            "Divorce / Separation",
            "Depression",
            "Chronic Disease Management",
            "Anxiety & Phobias",
            "Anger Management"
        ]
    },
    {
        "address2_postalcode": "LA1 1XX",
        "contactid": "f3b25e20-845a-eb11-a812-00224840f431",
        "address2_longitude": "-2.79937",
        "address2_line1": "Marton Street",
        "address2_country": "United Kingdom",
        "salutation": "Dr Ruth Elvish CPsychol",
        "address2_county": "Lancashire",
        "fullname": "Ruth Elvish",
        "address2_city": "Lancaster",
        "address2_composite": "Marton Street\r\nLancaster\r\nLA1 1XX\r\nUnited Kingdom",
        "address2_latitude": "54.04640",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Elvish",
        "email": "ruth.elvish@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "ruth.elvish@gmail.com",
        "website": "http://www.ruthelvish.co.uk/",
        "typeOfTreatment": [
            "Work Stress",
            "Suicide",
            "Stress Management",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "PTSD",
            "Psychosis",
            "Personality Disorders",
            "Panic Disorder",
            "OCD",
            "Neuropsychological Treatment / Rehabilitation",
            "Neuropsychological Assessment",
            "Mental Illness",
            "Memory Problems",
            "Life Transition & Adjustment Issues",
            "Grief and Loss",
            "Depression",
            "Dementia",
            "Bipolar Disorder",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_city": "TOTNES",
        "address2_line3": "Dartington Hall",
        "address2_line2": "The Old Postern",
        "address2_county": "Devon",
        "address2_postalcode": "TQ9 6EA",
        "address2_line1": "C/O The Old Postern",
        "salutation": "Dr Alexandra Lagaisse CPsychol",
        "contactid": "e72a8a53-175b-eb11-a812-00224840f431",
        "sbbps_donotincludedirectoryaddress": "No",
        "address2_composite": "C/O The Old Postern\r\nThe Old Postern\r\nDartington Hall\r\nTOTNES\r\nTQ9 6EA\r\nUnited Kingdom",
        "lastname": "Lagaisse",
        "fullname": "Alexandra Lagaisse",
        "address2_country": "United Kingdom",
        "address2_latitude": "50.45131",
        "address2_longitude": "-3.70911",
        "email": "alextoombes@hotmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "alextoombes@hotmail.com",
        "website": "",
        "typeOfTreatment": [
            "Work Stress",
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychosis",
            "Psychopathology Assessment",
            "Psychological Research",
            "Post-natal Depression",
            "Personality Disorders",
            "Personality Assessment",
            "Panic Disorder",
            "Organisational Environment",
            "OCD",
            "Mental Illness",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Legal Report",
            "Leadership",
            "Health-related Problems",
            "Grief and Loss",
            "Eating Disorders",
            "Domestic Violence",
            "Divorce / Separation",
            "Disaster / Terrorism",
            "Depression",
            "Cross-cultural",
            "Conflict Resolution",
            "Community Consultation / Evaluation",
            "Chronic Disease Management",
            "Carer Support",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assessment of Offenders",
            "Anxiety & Phobias",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_postalcode": "L31 1HW",
        "contactid": "16b8df5b-005b-eb11-a812-00224840f431",
        "address2_longitude": "-2.94315",
        "address2_line1": "Parkbourn",
        "address2_country": "United Kingdom",
        "salutation": "Mr Ryan Aguiar CPsychol AFBPsS",
        "address2_county": "Merseyside",
        "fullname": "Ryan Aguiar",
        "address2_city": "Liverpool",
        "address2_composite": "Parkbourn\r\nLiverpool\r\nL31 1HW\r\nUnited Kingdom",
        "address2_latitude": "53.51660",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Aguiar",
        "email": "ryan.aguiar@merseycare.nhs.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "ryan.aguiar@merseycare.nhs.uk",
        "website": "",
        "typeOfTreatment": [
            "Rehab / Injury Counselling",
            "PTSD",
            "Neuropsychological Treatment / Rehabilitation",
            "Neuropsychological Assessment",
            "Memory Problems",
            "Legal Report",
            "Impairment Assessment",
            "Expert Witness"
        ]
    },
    {
        "contactid": "ccadb0cb-d95a-eb11-a812-00224840fbeb",
        "address2_longitude": "0.00000",
        "address2_line1": "Milano, Italy",
        "address2_country": "Italy",
        "salutation": "Dr Francesca Emanuelli CPsychol",
        "fullname": "Francesca Emanuelli",
        "address2_composite": "Milano, Italy\r\nItaly",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Emanuelli",
        "email": "francesca.emanuelli@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "francesca.emanuelli@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Stress Management",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "School Issues",
            "Religious Issues",
            "Relationships",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychosis",
            "Psychological Research",
            "Post-natal Depression",
            "Personality Disorders",
            "Parenting",
            "Panic Disorder",
            "OCD",
            "Mental Illness",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Grief and Loss",
            "Eating Disorders",
            "Domestic Violence",
            "Divorce / Separation",
            "Depression",
            "Cross-cultural",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "Adoption"
        ]
    },
    {
        "address2_postalcode": "LE2 2FF",
        "contactid": "2ea7742e-815a-eb11-a812-00224840f431",
        "address2_line3": "Oadby",
        "address2_line2": "Gartree Road",
        "address2_line1": "Spire Hospital",
        "address2_country": "United Kingdom",
        "address2_longitude": "-1.08346",
        "salutation": "Dr Aftab Laher CPsychol CSci AFBPsS",
        "fullname": "Aftab Laher",
        "address2_city": "LEICESTER",
        "address2_composite": "Spire Hospital\r\nGartree Road\r\nOadby\r\nLEICESTER\r\nLE2 2FF\r\nUnited Kingdom",
        "address2_latitude": "52.61468",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Laher",
        "email": "al@psyworks.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "al@psyworks.co.uk",
        "website": "http://www.psyworks.co.uk/",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Vocational Assessment & Career Issues",
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Substance Abuse",
            "Stress Management",
            "Smoking Cessation",
            "Sleeping Disorders",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychosis",
            "Psychopathology Assessment",
            "Psychological Research",
            "Post-natal Depression",
            "Personnel Selection",
            "Personality Disorders",
            "Personality Assessment",
            "Performance Management",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "Organisational Restructuring",
            "OCD",
            "Neuropsychological Assessment",
            "Motivation in Sport",
            "Mental Illness",
            "Memory Problems",
            "Mediation",
            "Market / Consumer Research",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Legal Report",
            "Leadership",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Impulsive Behaviours",
            "Impairment Assessment",
            "Human Resource Management",
            "Health-related Problems"
        ]
    },
    {
        "address2_postalcode": "SW3 4UD",
        "contactid": "1fa8c83e-175b-eb11-a812-00224840fbeb",
        "address2_line3": "36-42 Kings Road",
        "address2_line2": "Suite 12 & 13",
        "address2_line1": "DoctorAna Solutions Ltd",
        "address2_country": "United Kingdom",
        "address2_longitude": "-0.16053",
        "salutation": "Dr Ana Aguirregabiria CPsychol AFBPsS",
        "fullname": "Ana Aguirregabiria",
        "address2_city": "London",
        "address2_composite": "DoctorAna Solutions Ltd\r\nSuite 12 & 13\r\n36-42 Kings Road\r\nLondon\r\nSW3 4UD\r\nUnited Kingdom",
        "address2_latitude": "51.49151",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Aguirregabiria",
        "email": "doctorana@mac.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "doctorana@mac.com",
        "website": "http://www.doctoranasolutions.com/",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Terminal Illness",
            "Teaching",
            "Suicide",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Difficulties",
            "Self Esteem & Self Development",
            "School Issues",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychological Research",
            "Post-natal Depression",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "Organisational Restructuring",
            "Organisational Environment",
            "OCD",
            "Neuropsychological Assessment",
            "Memory Problems",
            "Mediation",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Learning Difficulties",
            "Leadership",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Infertility Issues",
            "Impairment Assessment",
            "Health-related Problems",
            "Gender / Sexual Identity Disorders",
            "Divorce / Separation",
            "Dissociative Identity Disorder",
            "Disaster / Terrorism",
            "Depression",
            "Cult Involvement",
            "Cross-cultural",
            "Couples Therapy",
            "Conflict Resolution",
            "Chronic Disease Management",
            "Bullying",
            "Behaviour Problems",
            "Autism",
            "Aspergers"
        ]
    },
    {
        "address2_postalcode": "AL5 3EZ",
        "contactid": "1c907826-e55a-eb11-a812-00224840f431",
        "address2_line3": "Hertfordshire ",
        "address2_line2": "Harpenden",
        "address2_line1": "16 Wood End Hill",
        "address2_country": "United Kingdom",
        "address2_longitude": "-0.37966",
        "salutation": "Ms Lynette Eng CPsychol",
        "fullname": "Lynette Eng",
        "address2_composite": "16 Wood End Hill\r\nHarpenden\r\nHertfordshire \r\nAL5 3EZ\r\nUnited Kingdom",
        "address2_latitude": "51.82727",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Eng",
        "email": "lyn.eng11@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "lyn.eng11@gmail.com",
        "website": "http://www.lyneng.com/",
        "typeOfTreatment": [
            "Work Stress",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "PTSD",
            "Post-natal Depression",
            "Personality Disorders",
            "Panic Disorder",
            "Pain Management",
            "Mental Illness",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Legal Report",
            "Impulsive Behaviours",
            "Health-related Problems",
            "Grief and Loss",
            "Depression",
            "Conflict Resolution",
            "Chronic Disease Management",
            "Carer Support",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "Adoption"
        ]
    },
    {
        "contactid": "ef8ed34c-725a-eb11-a812-00224840fbeb",
        "address2_longitude": "0.00000",
        "address2_country": "United Kingdom",
        "salutation": "Dr Ann Laight CPsychol",
        "fullname": "Ann Laight",
        "address2_composite": "United Kingdom",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Laight",
        "email": "Ann@rootspsychologygroup.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "Ann@rootspsychologygroup.co.uk",
        "website": "",
        "typeOfTreatment": [
            "Suicide",
            "Self Harm",
            "Self Esteem & Self Development",
            "School Issues",
            "Relaxation",
            "Relationships",
            "Post-natal Depression",
            "Personality Disorders",
            "Parenting",
            "Orphanages / Children's Home Issues",
            "OCD",
            "Neuropsychological Assessment",
            "Life Transition & Adjustment Issues",
            "Intellectual Assessment",
            "Health-related Problems",
            "Grief and Loss",
            "Gender / Sexual Identity Disorders",
            "Eating Disorders",
            "Depression",
            "Carer Support",
            "Behaviour Problems",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management"
        ]
    },
    {
        "address2_postalcode": "CV47 2XY",
        "contactid": "5399c95a-d85a-eb11-a812-00224840f431",
        "address2_line2": "Fenny Compton",
        "address2_line1": "Bridge Street",
        "address2_country": "United Kingdom",
        "address2_longitude": "-1.39350",
        "salutation": "Mr Alton Ainley CPsychol AFBPsS",
        "address2_county": "Warwickshire",
        "fullname": "Alton Ainley",
        "address2_city": "SOUTHAM",
        "address2_composite": "Bridge Street\r\nFenny Compton\r\nSOUTHAM\r\nCV47 2XY\r\nUnited Kingdom",
        "address2_latitude": "52.16751",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ainley",
        "email": "alton@altonainley.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "alton@altonainley.com",
        "website": "http://www.altonainley.com/",
        "typeOfTreatment": [
            "Vocational Assessment & Career Issues",
            "Personnel Selection",
            "Personality Assessment",
            "Performance Management",
            "Managerial Advice / Consultancy",
            "Leadership",
            "Human Resource Management"
        ]
    },
    {
        "address2_postalcode": "BN43 5WD",
        "contactid": "4ccc08e2-a45a-eb11-a812-00224840fbeb",
        "address2_line2": "10 Western Road",
        "address2_line1": "Shoreham Osteopathy Centre",
        "address2_country": "United Kingdom",
        "address2_longitude": "-0.27350",
        "salutation": "Dr Sarah Ennion CPsychol",
        "address2_county": "West Sussex",
        "fullname": "Sarah Ennion",
        "address2_city": "Shoreham-By-Sea",
        "address2_composite": "Shoreham Osteopathy Centre\r\n10 Western Road\r\nShoreham-By-Sea\r\nBN43 5WD\r\nUnited Kingdom",
        "address2_latitude": "50.83419",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Ennion",
        "email": "info@feelingstuck.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "info@feelingstuck.co.uk",
        "website": "http://www.feelingstuck.co.uk/",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Victim of Crime",
            "Teaching",
            "Suicide",
            "Substance Abuse",
            "Stress Management",
            "Smoking Cessation",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "PTSD",
            "Psychosis",
            "Psychological Research",
            "Post-natal Depression",
            "Personality Disorders",
            "Panic Disorder",
            "Organisational Environment",
            "OCD",
            "Mental Illness",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Leadership",
            "Impulsive Behaviours",
            "Human Resource Management",
            "Domestic Violence",
            "Disaster / Terrorism",
            "Depression",
            "Cult Involvement",
            "Carer Support",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_postalcode": "B75 5BT",
        "contactid": "d07482be-155b-eb11-a812-00224840fbeb",
        "address2_line2": "46-48 Mere Green Road",
        "address2_line1": "Mulberry Offices Ltd",
        "address2_country": "United Kingdom",
        "address2_longitude": "-1.82495",
        "salutation": "Dr Shradha Lakhani CPsychol AFBPsS",
        "fullname": "Shradha Lakhani",
        "address2_city": "Sutton Coldfield",
        "address2_composite": "Mulberry Offices Ltd\r\n46-48 Mere Green Road\r\nSutton Coldfield\r\nB75 5BT\r\nUnited Kingdom",
        "address2_latitude": "52.58748",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Lakhani",
        "email": "shradha@compassionateminds.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "shradha@compassionateminds.uk",
        "website": "",
        "typeOfTreatment": [
            "Work Stress",
            "Terminal Illness",
            "Teaching",
            "Stress Management",
            "Sleeping Disorders",
            "Sexual Abuse",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "Psychological Research",
            "Panic Disorder",
            "Pain Management",
            "Organisational Environment",
            "Mental Illness",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Leadership",
            "Health-related Problems",
            "Grief and Loss",
            "Eating Disorders",
            "Depression",
            "Cross-cultural",
            "Couples Therapy",
            "Conflict Resolution",
            "Community Consultation / Evaluation",
            "Chronic Disease Management",
            "Bullying",
            "Behaviour Problems",
            "Assertiveness Training",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse"
        ]
    },
    {
        "address2_city": "LONDON",
        "address2_line3": "Crystal Palace Park Road",
        "address2_line2": "5, Agate House",
        "address2_county": "London",
        "address2_postalcode": "SE26 6UW",
        "address2_line1": "IMBT - Integrative Mindfulness Based Therapy",
        "salutation": "Mr Matthew Akal CPsychol AFBPsS",
        "contactid": "ce082d18-a35a-eb11-a812-00224840fbeb",
        "sbbps_donotincludedirectoryaddress": "No",
        "address2_composite": "IMBT - Integrative Mindfulness Based Therapy\r\n5, Agate House\r\nCrystal Palace Park Road\r\nLONDON\r\nSE26 6UW\r\nUnited Kingdom",
        "lastname": "Akal",
        "fullname": "Matthew Akal",
        "address2_country": "United Kingdom",
        "address2_latitude": "51.42482",
        "address2_longitude": "-0.06594",
        "email": "info@imbt.co.uk",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "info@imbt.co.uk",
        "website": "http://www.imbt.co.uk/",
        "typeOfTreatment": [
            "Workplace Bullying",
            "Work Stress",
            "Vocational Assessment & Career Issues",
            "Victim of Crime",
            "Test Development",
            "Terminal Illness",
            "Teaching",
            "Suicide",
            "Substance Abuse",
            "Stress Management",
            "Smoking Cessation",
            "Sleeping Disorders",
            "Sexual Difficulties",
            "Sexual Abuse",
            "Self Harm",
            "Self Esteem & Self Development",
            "Religious Issues",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychosis",
            "Psychopathology Assessment",
            "Psychological Research",
            "Post-natal Depression",
            "Personnel Selection",
            "Personality Disorders",
            "Personality Assessment",
            "Performance Management",
            "Performance in Sport",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "Orphanages / Children's Home Issues",
            "Organisational Restructuring",
            "Organisational Environment",
            "OCD",
            "Neuropsychological Treatment / Rehabilitation",
            "Neuropsychological Assessment",
            "Motivation in Sport",
            "Memory Problems",
            "Mediation",
            "Market / Consumer Research",
            "Managerial Advice / Consultancy",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Legal Report",
            "Learning Difficulties",
            "Leadership"
        ]
    },
    {
        "address2_postalcode": "A94 T293",
        "contactid": "459c54f6-735a-eb11-a812-00224840fbeb",
        "address2_line2": "Stillorgan",
        "address2_line1": "87 Weirview Drive",
        "address2_country": "Ireland",
        "address2_longitude": "0.00000",
        "salutation": "Mr John Lalor CPsychol",
        "fullname": "John Lalor",
        "address2_city": "Blackrock",
        "address2_composite": "87 Weirview Drive\r\nStillorgan\r\nBlackrock A94 T293\r\nIreland",
        "address2_latitude": "0.00000",
        "sbbps_donotincludedirectoryaddress": "No",
        "lastname": "Lalor",
        "email": "johnlalordublin@gmail.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "johnlalordublin@gmail.com",
        "website": "",
        "typeOfTreatment": [
            "Vocational Assessment & Career Issues",
            "Victim of Crime",
            "Stress Management",
            "Self Harm",
            "Self Esteem & Self Development",
            "Relaxation",
            "Relationships",
            "Rehab / Injury Counselling",
            "PTSD",
            "Post-natal Depression",
            "Personality Disorders",
            "Personality Assessment",
            "Parenting",
            "Panic Disorder",
            "Pain Management",
            "OCD",
            "Neuropsychological Assessment",
            "Motivation in Sport",
            "Life Transition & Adjustment Issues",
            "Life / Personal Coaching",
            "Learning Difficulties",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Infertility Issues",
            "Impairment Assessment",
            "Health-related Problems",
            "Grief and Loss",
            "Family problems",
            "Dyslexia assessment",
            "Dyscalculia",
            "Depression",
            "Cognitive Behavioural Therapy (CBT)",
            "Chronic Disease Management",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Autism",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "Adult Survivors of Sexual Abuse",
            "ADHD",
            "Academic Performance"
        ]
    },
    {
        "address2_city": "Erdington",
        "address2_line3": "Wood Lane ",
        "address2_line2": "Hastingwood Industrial Park",
        "address2_county": "BIRMINGHAM",
        "address2_postalcode": "B24 9QR",
        "address2_line1": "Park Business Centre ",
        "salutation": "Dr Kevin Epps CPsychol CSci AFBPsS",
        "contactid": "06454c3c-195b-eb11-a812-00224840f431",
        "sbbps_donotincludedirectoryaddress": "No",
        "address2_composite": "Park Business Centre \r\nHastingwood Industrial Park\r\nWood Lane \r\nErdington\r\nB24 9QR\r\nUnited Kingdom",
        "lastname": "Epps",
        "fullname": "Kevin Epps",
        "address2_country": "United Kingdom",
        "address2_latitude": "52.51108",
        "address2_longitude": "-1.82676",
        "email": "eppsilon9@aol.com",
        "phone": "07931229137",
        "workPhone": "07931229137",
        "workEmail": "eppsilon9@aol.com",
        "website": "http://www.pospath.com/",
        "typeOfTreatment": [
            "Work Stress",
            "Victim of Crime",
            "Suicide",
            "Stress Management",
            "Sexual Abuse",
            "Sex Offenders",
            "Self Harm",
            "Self Esteem & Self Development",
            "School Issues",
            "Race / Gender / Sexuality",
            "PTSD",
            "Psychosis",
            "Psychopathology Assessment",
            "Post-natal Depression",
            "Personality Disorders",
            "Personality Assessment",
            "Parenting",
            "Orphanages / Children's Home Issues",
            "OCD",
            "Mental Illness",
            "Mediation",
            "Management of Offenders",
            "Legal Report",
            "Learning Difficulties",
            "Intellectual Disability",
            "Intellectual Assessment",
            "Grief and Loss",
            "Family Court Issues",
            "Expert Witness",
            "Eating Disorders",
            "Dissociative Identity Disorder",
            "Depression",
            "Criminal Behaviour",
            "Carer Support",
            "Bullying",
            "Bipolar Disorder",
            "Behaviour Problems",
            "Autism",
            "Assessment of Offenders",
            "Assertiveness Training",
            "Aspergers",
            "Anxiety & Phobias",
            "Anger Management",
            "Adoption",
            "ADHD"
        ]
    },
]